module.exports = __webpack_public_path__ + "static/media/industry-alt.07f9afc0.svg";